import React, { Suspense } from 'react';
import { LoadingFallback } from '@/main/LoadingFallback.atom';
import type { CKEditorProps } from '@/annotation/CKEditor.organism';

const CKEditor = React.lazy(() => import('@/defaultExportShims/CKEditor'));

export const CKEditorAsync = (props: CKEditorProps) => {
  return (
    <Suspense fallback={<LoadingFallback />}>
      <CKEditor {...props}></CKEditor>
    </Suspense>
  );
};
